import locale_de_de from './locale_de_de';
import locale_en_us from './locale_en_us';
import locale_pt_br from './locale_pt_br';

let locales = {
    de_de: locale_de_de,
    en_us: locale_en_us,
    pt_br: locale_pt_br
};

export default locales;
